export default __webpack_public_path__ + "static/media/1.9462c402.jpg";